<div class="help-page">
  <div class="title">Das Bet3000 Support-Formular</div>

  <div class="help-text">
    Bei Fragen und Anliegen helfen wir Ihnen gerne persönlich weiter. Fülle dazu einfach unser Support-Formular aus oder schreibe eine Nachricht an support@ibc-betting.com. Wir
    melden uns schnellstmöglich bei dir.
  </div>

  <form class="help-login-form" [formGroup]="loginDatas">
    <mat-form-field appearance="fill" class="form-email">
      <mat-label>{{ 'user_name' | t }}</mat-label>
      <input matInput placeholder="{{ 'user_name' | t }}" type="text" formControlName="userName" required />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>{{ 'e_mail_address' | t }}</mat-label>
      <input matInput placeholder="{{ 'e_mail_address' | t }}" type="email" formControlName="email" required />
    </mat-form-field>

    <mat-form-field appearance="fill" class="form-email">
      <mat-label>{{ 'help_category' | t }}</mat-label>
      <mat-select class="category" placeholder="asd" formControlName="category" [(value)]="selectedCategory" required>
        <mat-option *ngFor="let x of categoryList" [value]="x.id">
          {{ x.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>{{ 'help_problem' | t }}</mat-label>
      <mat-select class="category" placeholder="asd" formControlName="problem" required>
        <mat-option *ngFor="let x of problemList" [value]="x.id">
          {{ x.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>{{ 'help_message' | t }}</mat-label>
      <textarea matInput placeholder="{{ 'help_message' | t }}" formControlName="message" rows="5"></textarea>
    </mat-form-field>

    <div class="button-box">
      <button mat-raised-button class="form-submit-button" (click)="SendMessage()" [disabled]="!loginDatas?.valid">{{ 'help_send_button' | t }}</button>
    </div>
  </form>
</div>
